import styled from "styled-components";

export const TakhliehTimeInputsStyled = styled.div`
  .ant-picker {
    border: none;
    border-radius: 8px;
    width: 100%;

    input {
      font-size: 0.9em;
    }
  }
`;
